import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import LeaderboardList from './leaderboard/LeaderboardList';
import ScoringRules from './leaderboard/ScoringRules';
import Achievements from './leaderboard/Achievements';
import Seasons from './leaderboard/Seasons';

const LeaderboardManagement: React.FC = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState<'leaderboards' | 'scoring' | 'achievements' | 'seasons'>('leaderboards');

  return (
    <div className="space-y-6 pt-16 lg:pt-0">
      {/* Header */}
      <div>
        <h2 className="text-4xl font-bold text-gradient-cyan mb-2">
          🏆 {t('leaderboard.title')}
        </h2>
      </div>

      {/* Tabs */}
      <div className="flex gap-2 border-b border-[#31383D] overflow-x-auto">
        <button
          onClick={() => setActiveTab('leaderboards')}
          className={`px-6 py-3 font-semibold transition-colors ${
            activeTab === 'leaderboards'
              ? 'text-cyan-400 border-b-2 border-cyan-400'
              : 'text-[#B8B8C3] hover:text-white'
          }`}
        >
          {t('leaderboard.leaderboards')}
        </button>
        <button
          onClick={() => setActiveTab('scoring')}
          className={`px-6 py-3 font-semibold transition-colors ${
            activeTab === 'scoring'
              ? 'text-cyan-400 border-b-2 border-cyan-400'
              : 'text-[#B8B8C3] hover:text-white'
          }`}
        >
          {t('leaderboard.scoringRules')}
        </button>
        <button
          onClick={() => setActiveTab('achievements')}
          className={`px-6 py-3 font-semibold transition-colors ${
            activeTab === 'achievements'
              ? 'text-cyan-400 border-b-2 border-cyan-400'
              : 'text-[#B8B8C3] hover:text-white'
          }`}
        >
          {t('leaderboard.achievements')}
        </button>
        <button
          onClick={() => setActiveTab('seasons')}
          className={`px-6 py-3 font-semibold transition-colors ${
            activeTab === 'seasons'
              ? 'text-cyan-400 border-b-2 border-cyan-400'
              : 'text-[#B8B8C3] hover:text-white'
          }`}
        >
          {t('leaderboard.seasons')}
        </button>
      </div>

      {/* Tab Content */}
      {activeTab === 'leaderboards' && <LeaderboardList />}
      {activeTab === 'scoring' && <ScoringRules />}
      {activeTab === 'achievements' && <Achievements />}
      {activeTab === 'seasons' && <Seasons />}
    </div>
  );
};

export default LeaderboardManagement;
